import { StepDefinitionStrategy } from './step-definition.strategy';
import { Injectable } from '@angular/core';
import { RouteIds, Step } from '../../types';
import { PackageDetailsComponent } from '../../components/package-details/package-details.component';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';

@Injectable({
  providedIn: 'root',
})
export class BookingStepDefinitionService implements StepDefinitionStrategy {
  private stepDefinition: Step = {
    id: RouteIds.booking,
    title: $localize`Enrolment form`,
    subtitles: [$localize`Please check your quote details and provide the following information to complete your enrolment.`],
    floatingPanel: {
      component: PackageDetailsComponent,
      position: 'title',
      enabledMobile: true,
      mobilePosition: 'top',
    },
    googleAnalyticsEvent: GoogleAnalyticsEventEnum.Booking,
    nextStep: () => RouteIds.confirmation,
  };

  getStepDefinition() {
    return {
      ...this.stepDefinition,
    };
  }
}
